import { createSlice } from "@reduxjs/toolkit";
import {Lesson,Group, Pagination} from "features/model/types/groups/groupsLessonsSchema";

const initialState = {
    lessons: [] as Lesson[],
    group: {} as Group,
    pagination: {} as Pagination ,
    IsLoading: true,
    error: null,
    startingSoon:false,
};

const groupsLessonsSlice = createSlice({
    name: "groupsLessons",
    initialState,
    reducers: {
        setGroupsLessons: (state, action) => {
            const { items, pagination, group,startingSoon} = action.payload;
            state.group = group;
            state.lessons = items;
            state.pagination = pagination;
            state.IsLoading = false;
            state.error = null;
            state.startingSoon = startingSoon;
        },
        setLoading: (state, action) => {
            state.IsLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setGroupsLessons, setLoading, setError } = groupsLessonsSlice.actions;


export const groupsLessonsReducer = groupsLessonsSlice.reducer;

